import { css } from '@emotion/react';
import { theme } from 'styles/theme';

export const NonExistingScreen = () => {
	return (
		<div
			css={css`
				display: flex;
				align-items: center;
				justify-content: center;
				height: 100%;
				flex-direction: column;
			`}
		>
			<div
				css={css`
					font-size: 32px;
					color: ${theme.color.text['400']};
					text-align: center;
					line-height: 40px;
					margin-bottom: 12px;
				`}
			>
				Neplatný odkaz
			</div>
			<div
				css={css`
					font-size: 16px;
					color: ${theme.color.text['300']};
					text-align: center;
					line-height: 24px;
					margin-bottom: 32px;
				`}
			>
				Požadavek na booking pod tímto odkazem neexistuje.
			</div>
		</div>
	);
};
